module.exports = __webpack_public_path__ + "app/components/devices/tracker/details.view.html";